import type { TabType } from '../store/tabStore';

export type FeatureStatus = 'idle' | 'loading' | 'ready' | 'error';
export interface FeatureSnapshot {
  features: Readonly<Record<string, boolean>>;
  status: FeatureStatus;
}

/** Presentation rules shared by navigation, page guards and every help surface. */
export function resolveCapabilities({ features: f, status }: FeatureSnapshot) {
  const ready = status === 'ready';
  const edit = ready && f.readOnly !== true;
  return {
    basic: true,
    edit,
    connectionCheck: edit && f.netzanschlusspruefung === true,
    planning: edit && f.stresstest !== false,
    switchingHistory: edit && f.schalthistorie !== false,
    forecast: ready && f.prognose !== false,
    control: edit && f.steuerung === true,
    controlDemo: edit && f.steuerung === true && f.controlDemo === true,
    diagnostics: ready && f.internalMetrics === true,
    meterReadings: ready && f.tafReadings === true,
  };
}

export type Capabilities = ReturnType<typeof resolveCapabilities>;
export type Capability = keyof Capabilities;

export function isTabAvailable(type: TabType, capabilities: Capabilities): boolean {
  switch (type) {
    case 'netzanschluss': return capabilities.connectionCheck;
    case 'stress': return capabilities.planning;
    case 'switching-history': return capabilities.switchingHistory;
    default: return true;
  }
}

/** Reject malformed discovery responses rather than silently enabling legacy defaults. */
export function parseFeatureResponse(value: unknown): Record<string, boolean> {
  if (value === null || typeof value !== 'object' || Array.isArray(value)
    || Object.values(value).some(flag => typeof flag !== 'boolean')) {
    throw new Error('Ungültige Funktionskonfiguration');
  }
  return value as Record<string, boolean>;
}
